<template>
  <div class="service-summary">
    <detail-generator
      v-for="(service, idx) in data"
      :key="`service-${idx}`"
      :details="details(service)"
      wrapper-class="bg-secondary-3 py-2 px-3 mb-2 rounded"
    />
    <div class="row mx-0 bg-gray-5 py-2 px-3 mb-3 rounded">
      <div class="col-5 col-md-6">
        <span class="font-weight-bold">Total</span>
      </div>
      <div class="col-md-2">
        <span class="font-weight-bold color-green">
          {{ totalCost | price }}
        </span>
      </div>
      <div class="col-md-2">
        <span class="font-weight-bold color-green">
          {{ totalBilled | price }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import DetailGenerator from './DetailGenerator.vue';
import { price } from '@/utils/filters';

export default {
  name: 'ServiceSummary',
  components: { DetailGenerator },
  filters: { price },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    totalCost() {
      return this.data.reduce((total, next) => (total += next.subTotal), 0);
    },
    totalBilled() {
      return this.data.reduce((total, next) => (total += next.totalBilled), 0);
    },
    details() {
      return (service) => {
        return [
          {
            info: [
              {
                label: 'Servicio:',
                data: service.service?.name,
                class: 'col-12 col-md-2',
              },
              {
                label: 'Frecuencia:',
                data:
                  service.frequency > 1
                    ? service.frequency - service.frequencyBilled
                    : service.frequency,
                class: 'col-12 col-md-2',
              },
              {
                label: 'Costo:',
                data: price(service.cost),
                class: 'col-12 col-md-2',
              },
              {
                label: 'Subtotal:',
                data: price(service.subTotal),
                class: 'col-12 col-md-2',
              },
              {
                label: 'Facturado:',
                data: price(service.totalBilled),
                class: 'col-12 col-md-2',
              },
              {
                label: 'Fecha de Aprobación:',
                data: service.startDate,
                class: 'col-12 col-md-2',
                filters: ['date'],
              },
            ],
          },
        ];
      };
    },
  },
};
</script>
